import { useConvexNotifications } from "../../../services/convexService";
import { Badge } from "../../../components/ui/badge";
import { Id } from "../../../../backend/_generated/dataModel";

interface NotificationBadgeProps {
  userId: Id<"users">;
}

const NotificationBadge = ({ userId }: NotificationBadgeProps) => {
  const { getUnreadNotifications } = useConvexNotifications();

  // Get unread notifications for the user
  const unreadNotifications = getUnreadNotifications(userId);

  // Calculate unread count
  const unreadCount = unreadNotifications ? unreadNotifications.length : 0;

  // Only show badge if there are unread notifications
  if (unreadCount === 0) {
    return null;
  }

  return (
    <Badge className="mr-auto bg-primary text-primary-foreground">
      {unreadCount}
    </Badge>
  );
};

export default NotificationBadge;